module.exports = __webpack_public_path__ + "media/flags/tm-06eedd0f.svg";